/// <amd-module name="Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataSaga" />
import { effects, SagaIterator } from "redux-saga";
import { ITfsPageService } from "Tfs/Platform/Page";
import { TfsPageDataActionsCreator } from "Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataActions";
import { IVssPageContext } from "VSS/Platform/Context";

export function* tfsPageDataSaga(): SagaIterator {
    const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
    const pageService: ITfsPageService = (yield effects.call([pageContext, pageContext.getService], "ITfsPageService")) as any;
    yield effects.put(TfsPageDataActionsCreator.tfsPageDataInitialized(pageService.getData()));
}
